import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const BatchProductTemperatureRangesImpactStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainGrid: {
            // marginTop: "30px",
            padding: "10px 50px 0px 50px",
        },

        specificationGrid: {
            marginTop: "20px",
        },

        gridTitle: {
            textTransform: "uppercase",

            color: "#525252",
            letterSpacing: "0.07em",
        },

        formButton: {
            color: theme.colors.primary.blue500,
        },

        formLoadingIndicator: {
            height: "40px",
            width: "40px",
        },

        table: {},
        tableHead: {},
        tableHeaderCell: {
            fontWeight: 500,
            fontSize: "18px",
        },
        tableBody: {},
        cellBorderBottom: {
            borderBottom: "none",
        },
    })
);
